var _path, _circle, _ellipse, _circle2, _line, _line2, _line3, _line4, _circle3, _circle4, _circle5, _circle6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _g, _path17, _line17, _line18, _line19, _line20, _line21, _rect, _path18, _g2, _g3, _path19, _ellipse2, _circle7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 264 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 97.3594C-3.51849e-05 113.191 13.2759 151 41.9933 167.631C71.3158 184.611 95.9 170.404 130.479 170.964C156.597 171.387 172.692 178.897 197.369 170.964C232.284 159.738 270.167 140.492 262.158 107.081C256.589 83.8452 230.067 84.2223 213.566 65.9734C197.105 47.7688 198.871 28.9742 178.472 14.5892C134.315 -16.5494 80.4618 6.78197 39.2937 41.2534C18.3756 58.7689 3.51851e-05 81.5274 0 97.3594Z",
    fill: "#031A6B",
    fillOpacity: 0.02
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 142.621,
    cy: 50.8277,
    r: 29.5862,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 49.3103,
    ry: 47.7931,
    transform: "matrix(-1 0 0 1 77.3796 115.31)",
    stroke: "#CAD0E1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.52,
    cy: 92.1035,
    r: 22.414,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 91.7987,
    y1: 30.1339,
    x2: 91.7987,
    y2: 30.7731,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 91.7987,
    y1: 35.2274,
    x2: 91.7987,
    y2: 35.8666,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 88.5472,
    y1: 32.6154,
    x2: 89.1864,
    y2: 32.6154,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 93.0995,
    y1: 32.6154,
    x2: 93.7387,
    y2: 32.6154,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.759,
    cy: 122.518,
    r: 20.1035,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5713,
    cy: 33.1092,
    r: 2.83213,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.335,
    cy: 13.3854,
    r: 1.73092,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.487,
    cy: 91.9013,
    r: 1.73092,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9909 151.023C82.9909 152.955 81.5482 154.436 79.8684 154.436C78.1885 154.436 76.7458 152.955 76.7458 151.023C76.7458 149.092 78.1885 147.61 79.8684 147.61C81.5482 147.61 82.9909 149.092 82.9909 151.023Z",
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.644 58.8063C192.082 89.0813 171.984 112.724 159.381 120.76L159.381 122.897C193.717 98.4812 181.863 69.9966 171.644 58.8063Z",
    fill: "#CAD0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.366 56.9751C165.768 54.1266 155.753 47.3921 152.483 43.2415C157.507 43.4449 168.118 46.4765 170.366 56.9751Z",
    fill: "#CAD0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.709 67.962C171.984 68.5724 165.103 68.0231 159.381 60.9426C162.739 59.6201 170.507 59.1725 174.709 67.962Z",
    fill: "#CAD0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.286 85.6632C175.561 84.5441 169.855 80.2918 168.833 72.2347C172.666 72.3364 179.921 75.1646 178.286 85.6632Z",
    fill: "#CAD0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.709 101.533C172.58 100.211 168.578 95.1852 169.6 85.6632C173.262 86.7822 179.41 91.5229 174.709 101.533Z",
    fill: "#CAD0E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.468 115.877C162.532 112.724 161.476 105.073 164.746 99.702C167.897 101.635 172.052 107.576 163.468 115.877Z",
    fill: "#CAD0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.833 117.708C170.792 114.656 176.958 108.064 185.951 106.111C183.992 111.299 177.826 120.882 168.833 117.708Z",
    fill: "#CAD0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.819 101.533C181.267 97.2605 185.542 88.2878 191.06 86.5787C191.647 91.5636 190.22 101.533 179.819 101.533Z",
    fill: "#CAD0E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.396 84.7476C183.14 79.4576 183.702 68.3893 187.994 66.4361C190.379 70.9122 192.797 80.8411 183.396 84.7476Z",
    fill: "#CAD0E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.819 66.4361C179.819 66.4361 173.943 59.4166 177.264 48.1245C180.841 52.1327 186.359 61.4064 179.819 66.4361Z",
    fill: "#CAD0E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.614 94.1765C151.614 94.1765 154.294 93.7443 155.435 92.6033C156.576 91.4622 157.008 88.7825 157.008 88.7825C157.008 88.7825 157.441 91.4622 158.582 92.6033C159.723 93.7443 162.402 94.1765 162.402 94.1765C162.402 94.1765 159.723 94.6088 158.582 95.7498C157.441 96.8908 157.008 99.5706 157.008 99.5706C157.008 99.5706 156.576 96.8908 155.435 95.7498C154.294 94.6088 151.614 94.1765 151.614 94.1765Z",
    fill: "#CAD0E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.793 73.6702C201.793 73.6702 204.473 73.2379 205.614 72.0969C206.755 70.9559 207.188 68.2761 207.188 68.2761C207.188 68.2761 207.62 70.9559 208.761 72.0969C209.902 73.2379 212.582 73.6702 212.582 73.6702C212.582 73.6702 209.902 74.1024 208.761 75.2434C207.62 76.3845 207.188 79.0642 207.188 79.0642C207.188 79.0642 206.755 76.3845 205.614 75.2434C204.473 74.1024 201.793 73.6702 201.793 73.6702Z",
    fill: "#CAD0E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208.528 88.5425C208.528 88.5425 211.828 88.0103 213.233 86.6054C214.637 85.2006 215.17 81.9012 215.17 81.9012C215.17 81.9012 215.702 85.2006 217.107 86.6054C218.512 88.0103 221.811 88.5425 221.811 88.5425C221.811 88.5425 218.512 89.0747 217.107 90.4795C215.702 91.8844 215.17 95.1838 215.17 95.1838C215.17 95.1838 214.637 91.8844 213.233 90.4795C211.828 89.0747 208.528 88.5425 208.528 88.5425Z",
    fill: "#CAD0E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.914 157.665C117.914 157.665 121.213 157.132 122.618 155.728C124.023 154.323 124.555 151.023 124.555 151.023C124.555 151.023 125.088 154.323 126.492 155.728C127.897 157.132 131.197 157.665 131.197 157.665C131.197 157.665 127.897 158.197 126.492 159.602C125.088 161.006 124.555 164.306 124.555 164.306C124.555 164.306 124.023 161.006 122.618 159.602C121.213 158.197 117.914 157.665 117.914 157.665Z",
    fill: "#CAD0E1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 36.526,
    y1: 62.296,
    x2: 36.526,
    y2: 64.0113,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 36.526,
    y1: 68.066,
    x2: 36.526,
    y2: 69.7813,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 32.1986,
    y1: 65.454,
    x2: 33.9138,
    y2: 65.454,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 37.9684,
    y1: 65.454,
    x2: 39.6836,
    y2: 65.454,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 30.629,
    y1: 71.3172,
    x2: 21.5735,
    y2: 80.4748,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 29.8587,
    y1: 77.0994,
    x2: 13.4641,
    y2: 93.6045,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 3.02127,
    y2: -1.30603,
    transform: "matrix(2.7095e-08 1 1 -3.13413e-08 203.365 116.828)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 3.02127,
    y2: -1.30603,
    transform: "matrix(2.7095e-08 1 1 -3.13413e-08 203.365 122.598)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 2.71747,
    y2: -1.30603,
    transform: "matrix(-1 -1.45705e-08 -1.45705e-08 1 207.389 122.598)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 2.71747,
    y2: -1.30603,
    transform: "matrix(-1 -1.56706e-08 -1.35475e-08 1 202.024 122.598)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 13.6571,
    y2: -1.30603,
    transform: "matrix(0.676828 0.736141 0.685017 -0.728527 207.218 126.195)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 23.6841,
    y2: -1.30603,
    transform: "matrix(0.678477 0.734622 0.68338 -0.730063 208.355 131.09)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23_13011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.2417,
    y: 93.7,
    width: 72.8276,
    height: 45.9964,
    rx: 8,
    transform: "rotate(-8.69553 43.2417 93.7)",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0315 98.864C43.5953 96.012 45.5537 93.3463 48.4058 92.9101L110.068 83.4794C112.92 83.0432 115.586 85.0017 116.022 87.8537L116.826 93.1093L44.8353 104.12L44.0315 98.864Z",
    fill: "#D9DDE9"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 86.7986,
    y1: 118.339,
    x2: 111.343,
    y2: 114.585,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 85.6882,
    y1: 111.077,
    x2: 110.232,
    y2: 107.324,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 84.5779,
    y1: 103.815,
    x2: 109.122,
    y2: 100.061,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 87.9094,
    y1: 125.602,
    x2: 107.717,
    y2: 122.572,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 49.6853,
    y1: 97.5185,
    x2: 66.6516,
    y2: 94.9237,
    stroke: "white",
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.9543,
    y: 108.466,
    width: 25.873,
    height: 25.873,
    rx: 3,
    transform: "rotate(-8.69553 49.9543 108.466)",
    fill: "#D9DDE9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3752 125.293C68.6148 124.696 67.6525 123.983 67.3773 122.184C67.2122 121.105 67.9598 120.274 68.1096 119.304C68.2594 118.334 68.2604 117.213 68.2786 116.395C68.2968 115.576 68.3053 115.26 68.2516 114.399C68.1827 113.325 67.0871 110.693 63.4663 111.247C59.8466 111.8 59.5857 114.64 59.843 115.685C60.049 116.522 60.1522 116.822 60.4138 117.598C60.6755 118.373 61.0099 119.443 61.4426 120.324C61.8752 121.205 62.838 121.774 63.0032 122.853C63.2783 124.652 62.573 125.62 60.1171 127.014C57.652 128.412 56.1032 129.656 56.2095 130.351L56.7075 133.607L76.5996 130.565L76.1016 127.309C75.9954 126.615 74.1446 125.891 71.3752 125.293Z",
    fill: "#B3BAD3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_23_13011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.311 98.4169C153.713 103.376 149.209 106.911 144.25 106.314L85.5428 99.2396C80.5839 98.6423 77.0485 94.1382 77.6459 89.1794L81.3073 58.7898C81.9055 53.8309 86.4095 50.2954 91.3684 50.8937L150.075 57.967C155.034 58.5636 158.57 63.0684 157.972 68.0273L154.311 98.4169Z",
    fill: "#E2E6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.165 90.4275L101.27 85.0179L101.355 84.3277L146.248 89.7365L146.165 90.4275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.665 94.5723L100.771 89.1627L100.854 88.4725L145.748 93.8813L145.665 94.5723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.491 91.1008L101.841 91.7993C101.933 91.9807 102.008 92.1472 102.087 92.327L102.106 92.3287C102.227 92.1605 102.344 92.0172 102.464 91.868L102.964 91.2781L103.556 91.3502L102.353 92.6808L103.223 94.3628L102.601 94.2882L102.242 93.5574C102.145 93.3685 102.065 93.1896 101.981 92.9957L101.968 92.994C101.847 93.1622 101.722 93.3122 101.589 93.4779L101.072 94.1035L100.469 94.0314L101.723 92.6237L100.881 91.027L101.491 91.1008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.369 91.4484L104.72 92.1469C104.812 92.3284 104.886 92.4949 104.965 92.6739L104.984 92.6764C105.105 92.5082 105.223 92.364 105.342 92.2157L105.842 91.6258L106.434 91.697L105.231 93.0285L106.102 94.7104L105.48 94.6351L105.119 93.9043C105.023 93.7154 104.943 93.5364 104.86 93.3425L104.847 93.3417C104.726 93.5099 104.6 93.659 104.467 93.8247L103.95 94.4511L103.347 94.3782L104.601 92.9713L103.76 91.3747L104.369 91.4484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.246 91.7945L107.598 92.4938C107.69 92.6745 107.764 92.8418 107.844 93.02L107.862 93.0233C107.984 92.8543 108.101 92.7101 108.221 92.5626L108.72 91.9727L109.311 92.0439L108.11 93.3746L108.98 95.0574L108.357 94.982L107.998 94.2512C107.901 94.0623 107.821 93.8833 107.738 93.6894L107.724 93.6886C107.603 93.856 107.478 94.0059 107.345 94.1717L106.828 94.7972L106.226 94.7243L107.479 93.3174L106.637 91.7208L107.246 91.7945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.125 92.1417L110.476 92.8402C110.568 93.0216 110.642 93.1882 110.722 93.3671L110.74 93.3696C110.862 93.2023 110.979 93.0581 111.099 92.9089L111.598 92.319L112.19 92.3903L110.988 93.7218L111.858 95.4045L111.236 95.3291L110.876 94.5975C110.779 94.4095 110.7 94.2297 110.616 94.0366L110.603 94.0349C110.482 94.2031 110.357 94.3523 110.223 94.5188L109.707 95.1444L109.104 95.0715L110.357 93.6646L109.516 92.068L110.125 92.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.003 92.4879L113.354 93.1864C113.446 93.3678 113.52 93.5344 113.599 93.7142L113.617 93.7166C113.739 93.5484 113.858 93.4043 113.976 93.256L114.477 92.666L115.067 92.7365L113.866 94.0679L114.736 95.7507L114.114 95.6762L113.754 94.9446C113.657 94.7556 113.578 94.5767 113.494 94.3836L113.481 94.382C113.36 94.5493 113.235 94.6985 113.101 94.8658L112.584 95.4906L111.981 95.4177L113.235 94.0116L112.394 92.4142L113.003 92.4879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.881 92.8349L116.232 93.5334C116.323 93.7148 116.398 93.8814 116.478 94.0612L116.496 94.0628C116.618 93.8955 116.735 93.7513 116.855 93.6022L117.355 93.0122L117.945 93.0835L116.743 94.4141L117.613 96.0969L116.992 96.0224L116.632 95.2907C116.535 95.1027 116.456 94.9229 116.372 94.7298L116.359 94.7282C116.238 94.8964 116.113 95.0455 115.979 95.212L115.462 95.8376L114.86 95.7647L116.113 94.3586L115.272 92.7612L115.881 92.8349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6 94.4262L119.551 94.8289L118.015 94.6449L118.064 94.2398L119.6 94.4262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63 93.4071L120.981 94.1056C121.073 94.287 121.147 94.4535 121.227 94.6333L121.245 94.635C121.367 94.4676 121.485 94.3235 121.604 94.1752L122.103 93.5844L122.695 93.6557L121.493 94.9871L122.363 96.6699L121.741 96.5945L121.381 95.8629C121.285 95.6748 121.205 95.495 121.121 95.302L121.108 95.3003C120.987 95.4685 120.862 95.6177 120.728 95.7842L120.212 96.4098L119.608 96.3368L120.863 94.9308L120.02 93.3333L120.63 93.4071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.507 93.7541L123.858 94.4526C123.95 94.634 124.025 94.8006 124.104 94.9804L124.122 94.982C124.244 94.8138 124.362 94.6705 124.481 94.5213L124.981 93.9314L125.572 94.0027L124.37 95.3333L125.24 97.0161L124.619 96.9415L124.259 96.2099C124.162 96.0219 124.083 95.8421 123.998 95.649L123.986 95.6473C123.865 95.8155 123.739 95.9647 123.606 96.1312L123.089 96.7568L122.486 96.6839L123.74 95.2778L122.899 93.6804L123.507 93.7541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.386 94.1007L126.736 94.7992C126.828 94.9806 126.903 95.1471 126.982 95.3269L127.001 95.3286C127.122 95.1612 127.24 95.0171 127.359 94.8688L127.86 94.278L128.451 94.3501L127.249 95.6807L128.118 97.3635L127.497 97.2881L127.137 96.5573C127.04 96.3684 126.961 96.1886 126.876 95.9956L126.864 95.9939C126.743 96.163 126.618 96.3113 126.484 96.4778L125.967 97.1034L125.364 97.0313L126.619 95.6244L125.776 94.0278L126.386 94.1007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.264 94.4471L129.616 95.1464C129.708 95.3279 129.781 95.4944 129.861 95.6742L129.879 95.6759C130.001 95.5077 130.119 95.3643 130.238 95.2152L130.737 94.6253L131.329 94.6973L130.127 96.028L130.997 97.71L130.375 97.6354L130.016 96.9046C129.919 96.7157 129.838 96.5359 129.755 96.3429L129.742 96.3412C129.621 96.5094 129.495 96.6594 129.362 96.8251L128.846 97.4506L128.243 97.3785L129.496 95.9708L128.655 94.3742L129.264 94.4471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.141 94.7951L132.493 95.4936C132.585 95.675 132.659 95.8416 132.739 96.0205L132.757 96.023C132.878 95.8548 132.995 95.7107 133.116 95.5624L133.615 94.9724L134.206 95.0437L133.005 96.3752L133.875 98.0571L133.252 97.9817L132.893 97.2509C132.796 97.062 132.716 96.8831 132.633 96.6892L132.619 96.6884C132.498 96.8566 132.373 97.0057 132.24 97.1714L131.723 97.7978L131.12 97.7249L132.374 96.318L131.532 94.7214L132.141 94.7951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.99 71.1604C151.645 74.0214 149.047 76.0613 146.185 75.7158L117.177 72.2209C114.317 71.8762 112.277 69.2779 112.621 66.4169C112.966 63.5551 115.564 61.516 118.426 61.8607L147.434 65.3564C150.295 65.7011 152.336 68.2994 151.99 71.1604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.697 75.1748L138.935 74.8426L140.182 64.4815L142.946 64.8146L141.697 75.1748Z",
    fill: "#031A6B",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.862 74.5928L132.718 74.0932L133.966 63.7338L138.11 64.2326L136.862 74.5928Z",
    fill: "#031A6B",
    fillOpacity: 0.06
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_23_13011)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 138.35,
    cy: 102.993,
    r: 26.9228,
    fill: "#B5D8D4",
    fillOpacity: 0.75,
    stroke: "#4EA699",
    strokeWidth: 9.14224
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.406,
    y: 135.448,
    width: 13.5856,
    height: 40.1393,
    rx: 6.79281,
    transform: "rotate(-45 154.406 135.448)",
    fill: "#4EA699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.772 151.894L175.25 156.316C180.507 161.509 189.251 156.415 187.327 149.28L187.494 149.444C190.191 152.074 190.218 156.401 187.554 159.065C184.919 161.7 180.65 161.707 178.007 159.081L170.772 151.894Z",
    fill: "#4B978C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.80324,
    height: 9.16983,
    rx: 2.40162,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 159.654 134.487)",
    fill: "#4EA699"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.838,
    y1: 133.87,
    x2: 179.107,
    y2: 143.138,
    stroke: "white",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.189,
    y1: 146.22,
    x2: 184.664,
    y2: 148.696,
    stroke: "white",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.315 83.1117C153.541 84.9742 156.258 87.6035 158.225 90.7668C160.192 93.93 161.348 97.5296 161.592 101.247C161.836 104.964 161.159 108.683 159.622 112.076C158.084 115.469 155.734 118.431 152.779 120.698C149.823 122.966 146.355 124.47 142.679 125.076C139.004 125.683 135.236 125.374 131.709 124.177C128.182 122.979 125.004 120.931 122.458 118.212C119.911 115.493 118.075 112.189 117.111 108.59C117.874 111.439 121.527 114.18 123.543 116.332C125.995 117.748 128.824 118.956 131.616 119.903C134.409 120.851 139.001 120.902 141.911 120.422C144.821 119.942 147.567 118.751 149.907 116.956C152.247 115.16 154.451 112.71 155.668 110.024C156.886 107.337 157.715 102.27 157.522 99.3274C157.329 96.3845 157.226 92.7029 155.668 90.1984C154.111 87.6939 152.869 84.5863 150.315 83.1117Z",
    fill: "white",
    fillOpacity: 0.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.044,
    cy: 86.221,
    rx: 9.12328,
    ry: 6.29191,
    transform: "rotate(-2.6891 137.044 86.221)",
    fill: "white",
    fillOpacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.243,
    cy: 90.2158,
    r: 2.4176,
    transform: "rotate(-2.6891 123.243 90.2158)",
    fill: "white",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23_13011",
    x: 39.134,
    y: 81.1938,
    width: 87.1599,
    height: 64.6936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_13011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_13011",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_23_13011",
    x: 72.3559,
    y: 50.8276,
    width: 90.9063,
    height: 66.0003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.22414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_13011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_13011",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_23_13011",
    x: 101.632,
    y: 71.499,
    width: 93.1739,
    height: 99.9949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.22414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.815686 0 0 0 0 0.882353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_13011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_13011",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditPending);
export default __webpack_public_path__ + "static/media/credit-pending.2bc7cb75e3d89be85390f74cff2546e9.svg";
export { ForwardRef as ReactComponent };